import React from 'react';
import { Auth, Hub } from 'aws-amplify';
import { useState } from 'react';
import Login from './Login';
import { LinearProgress } from '@mui/material';
import { useEffect } from 'react';
import './Auth.scss';
import { useSelector } from 'react-redux';

export default function CustomAuthenticator({ children }) {
    const [status, setStatus] = useState(null);
    const customization = useSelector((state) => state.customization);

    const accToken = sessionStorage.getItem('accessToken');
    const encReq = sessionStorage.getItem('documentID');
    const isDoc = customization?.openApp;

    useEffect(() => {
        if (Boolean(encReq) && Boolean(accToken) && Boolean(isDoc)) {
            setStatus('signIn');
        } else {
            setStatus('signOut');
        }
    }, [accToken, encReq, isDoc]);

    if (status === null) return <LinearProgress />;

    if (status === 'signIn') return children;

    if (status === 'signOut') return <Login />;
    else
        return (
            <center>
                <h1>{status}</h1>
            </center>
        );
}
